import { render, staticRenderFns } from "./OrganizationsWorkflowsList.vue?vue&type=template&id=7d13320c&scoped=true"
import script from "./OrganizationsWorkflowsList.vue?vue&type=script&lang=js"
export * from "./OrganizationsWorkflowsList.vue?vue&type=script&lang=js"
import style0 from "./OrganizationsWorkflowsList.vue?vue&type=style&index=0&id=7d13320c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d13320c",
  null
  
)

export default component.exports